import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import {
    useForm,
    useAuth,
    useFetch,
    useResource,
    useGrid,
    useModal,
    useStore,
    useToast,
    usePopup,
    usePage,
} from "@/comn/hooks"; // hook
import {
    APIS,
    SF_MANL_INFO_SEARCH_FORM,
    SG_MANL_INFO_LIST,
    URLS,
} from "@/tra/tancis/ptli/ptl/manl/service/PtliManlService";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

/*
 * Screen Manual Information List
 * !== 화면 매뉴얼 정보 목록 ==!
 */
export const PTLI0411001Q = (): JSX.Element => {
    useResource({
        defaultSchema: [
            { area: "bsopClsfCd" },
            { area: "comnCd", comnCd: "COM0024" },
            { area: "comnCd", comnCd: "COM0052" },
        ],
    });

    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0019"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        manlSrch: useForm({
            defaultSchema: SF_MANL_INFO_SEARCH_FORM,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의  ==!
     */
    const grid = {
        manlSrchList: useGrid({
            defaultSchema: SG_MANL_INFO_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getManlList: useFetch({
            api: (page = grid.manlSrchList.page) => {
                form.manlSrch.setValue("menuId", menuId);
                return APIS.getManlList(form.manlSrch.getValues(), page, grid.manlSrchList.size);
            },
            enabled: comnUtils.isEmpty(form.manlSrch.errors),
            key: [grid.manlSrchList.page, grid.manlSrchList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.manlSrch.getValues(),
                    page: grid.manlSrchList.page,
                    size: grid.manlSrchList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        getManlList: () => {
            grid.manlSrchList.setPage(0);
            fetch.getManlList.fetch(0);
        },
    };

    /*
     * Declaration Event Render
     * !== 랜더 정의 ==!
     */
    const render = {
        grid_manlSrchList: {
            cell: {
                scrnId: (props: any) => {
                    const { rowValues, value } = props;
                    return <Link to={`/ptli/ptl/manl/ptli0411003s/${rowValues.scrnId}`}>{value}</Link>;
                },
            },
        },
    };

    useEffect(() => {
        handler.getManlList();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.manlSrch.schema.bsopClsfCd} />
                            {menuId == "menu_ptli0021" ? null : <Group.Control {...form.manlSrch.schema.ptlTpCd} />}
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.manlSrch.schema.scrnId} />
                            <Group.Control {...form.manlSrch.schema.scrnNm} />
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.manlSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.getManlList} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.manlSrchList.grid}
                            data={fetch.getManlList.data?.manlList}
                            render={render.grid_manlSrchList}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        hidden={menuId != "menu_ptli0086"}
                        role="new"
                        onClick={() => {
                            navigate(URLS.ptli0411002s);
                        }}
                    />
                </Layout.Left>
            </Layout>
        </Page>
    );
};
